module.exports = __webpack_public_path__ + "static/media/TeoriaKolorow.c2569690.png";